import { findLastIndexWhere } from "./binarySearch";

export const findValueAtOrBefore = (
	data: [number, number | null][],
	time: number,
): number | null => {
	const index = findLastIndexWhere(data, (point) => point[0] <= time);
	return index >= 0 ? data[index][1] : null;
};

export const hasValueAt = (
	data: [number, number | null][],
	time: number,
): boolean => {
	const index = findLastIndexWhere(data, (point) => point[0] <= time);
	return index >= 0 && data[index][0] === time && data[index][1] !== null;
};
